<template>
  <div class="deprecation-banner">
    <div class="deprecation-content">
      <feather-icon icon="AlertTriangleIcon" svgClasses="w-5 h-5 mr-3" />
      <div class="deprecation-text">
        <strong>Service Deprecation Notice:</strong>
        Hoverlay Studio will be retired on September 30th, 2026. No new accounts can be created.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeprecationBanner'
}
</script>

<style lang="scss" scoped>
.deprecation-banner {
  background: #ff9f43;
  color: #fff;
  padding: 12px 20px;
  position: sticky;
  top: 0;
  z-index: 99999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.deprecation-content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.deprecation-text {
  font-size: 14px;
  line-height: 1.5;

  strong {
    font-weight: 600;
    margin-right: 6px;
  }
}

@media (max-width: 768px) {
  .deprecation-banner {
    padding: 10px 15px;
  }

  .deprecation-text {
    font-size: 13px;
  }
}
</style>
